// extracted by mini-css-extract-plugin
module.exports = {"errorText":"YaMapUnavailable_errorText__2JJSE","title":"YaMapUnavailable_title__R3b3Y","description":"YaMapUnavailable_description__29e-C","image":"YaMapUnavailable_image__XYVgZ"};